import { AccommodationProduct, AccommodationTypeValue, AddOnsProduct, CourseIntensityDto, CourseProduct, Fee, CancellationFee, PackageProduct, ProductCategory, ProductDivision, TransferPort, TransferType, TransfersProduct, UnitType, AccountCategory,CommissionCategory, Languages } from "app/shared/model"
import { FormError } from "app/shared/model/Form"
import { Product } from "app/shared/model/ProductBase"

export enum ActionType {
    PageLaded = 'ProductsList/PageLoaded',
    ChangeSearchTerm = 'ProductsList/ChangeSearchTerm',
    ChangeSelectedProductType = 'ProductList/ChangeSelectedProductType',
    FilterData = 'ProductList/FilterData',
    ListAccommodationProductsData ='ProductList/ListAccommodationProducts',
    ListCoursesData = 'ProductList/ListCourseProducts',
    ListAddOns = 'ProductList/ListAddOnsProducts',
    ListTransfers = 'ProductList/ListTransfersProducts',
    ListFees = 'ProductList/ListFees',
    ListCancellationFees = 'ProductList/ListCancellationFees',
    ListPackages = 'ProductList/ListPackageProducts',
    GetCourseProductData = 'ProductList/GetCourseProduct',    
    GetAccommodationProduct = 'ProductList/GetAccommodationProduct',    
    GetTransferProduct = 'ProductList/GetTransferProduct',    
    GetAddonProduct = 'ProductList/GetAddonProduct',
    GetFeeProduct = 'ProductList/GetFeeProduct',
    GetPackageProduct = 'ProductList/GetPackageProduct',
    SetCourseProductName = 'ProductList/SetCourseProductName',  
    GetCourseProductName = 'ProductList/GetCourseProductName',
    SetCourseProductIntensity = 'ProductList/SetCourseProductIntensity',  
    SetCourseDivision = 'ProductList/SetCourseDivision', 
    CancelShowDeleteCourseAction = 'ProductList/CancelShowDeleteCourseAction',
    CancelShowDeleteAccommodationAction = 'ProductList/CancelShowDeleteAccommodationAction',
    SetFormErrors = 'Pricelist/SetFormErrors',
    UpdateDraftAccommodationProduct = 'Product/UpdateDraftAccommodationProduct',
    LoadDraftAccommodationProduct= 'Product/LoadDraftAccommodationProduct',
    CancelShowDeleteAddOnAction = 'ProductList/CancelShowDeleteAddOnAction',    
    CancelShowDeleteTransferAction = 'ProductList/CancelShowDeleteTransferAction', 
    UpdateDraftAddOnProduct = 'Product/UpdateDraftAddOnProduct',
    LoadDraftAddOnProduct= 'Product/LoadDraftAddOnProduct',
    UpdateDraftTransferProduct = 'Product/UpdateDraftTransferProduct',
    LoadDraftTransferProduct='Product/LoadDraftTransferProduct',
    CancelShowDeleteFeeAction = 'ProductList/CancelShowDeleteFeeAction',
    GetCancellationFeeProduct = 'ProductList/GetCancellationFeeProduct',
    CancelShowDeleteCancellationFeeAction = 'ProductList/CancelShowDeleteCancellationFeeAction',
    UpdateDraftCancellationFeeProduct = 'Product/UpdateDraftCancellationFeeProduct',
    LoadDraftCancellationFeeProduct = 'Product/LoadDraftCancellationFeeProduct',
    UpdateDraftFeeProduct = 'Product/UpdateDraftFeeProduct',
    LoadDraftFeeProduct= 'Product/LoadDraftFeeProduct',
    CancelShowDeletePackageAction = 'ProductList/CancelShowDeletePackageAction',
    UpdateDraftPackageProduct = 'Product/UpdateDraftPackageProduct',
    LoadDraftPackageProduct = 'Product/LoadDraftPackageProduct',
}

export type PageLoadedEvent = {
    type: ActionType.PageLaded
    courseIntensity:CourseIntensityDto[],
    productDivisions:ProductDivision[],
    accommodationTypes:AccommodationTypeValue[],
    unitTypes:UnitType[],
    transferTypes:TransferType[],
    transferPorts:TransferPort[],
    productCategories: ProductCategory[],
    accountCategories: AccountCategory[],
    commissionCategories: CommissionCategory[],
    languages: Languages[],
    formErrors: FormError[],
}

export type PageLoadedData = {
    courseIntensity:CourseIntensityDto[],
}

export type ChangeSearchTerm = {
    type: ActionType.ChangeSearchTerm,
    searchTerm: string
}

export type ChangeSelectedProductType = {
    type: ActionType.ChangeSelectedProductType,
    selectedProductType: string,
    tabChanged: boolean
}

export type FilterData = {
    type: ActionType.FilterData,
    filteredData?: Product[]
}

export type ListAccommodationProductsData = {
    type: ActionType.ListAccommodationProductsData,
    accommodationProducts: AccommodationProduct[]
}

export type ListCourseProductsData = {
    type: ActionType.ListCoursesData,
    courseProducts: CourseProduct[]
}

export type GetCourseProductData = {
    type: ActionType.GetCourseProductData,
    courseProduct: CourseProduct
}

export type ListAddOnsProductsData = {
    type: ActionType.ListAddOns,
    addOnsProducts: AddOnsProduct[]
}

export type ListTransfersProductsData = {
    type: ActionType.ListTransfers,
    transferProducts: TransfersProduct[]
}

export type ListFeesProductsData = {
    type: ActionType.ListFees,
    feesProducts: Fee[]
}

export type ListCancellationFeesProductsData = {
    type: ActionType.ListCancellationFees,
    cancellationFeeProducts: CancellationFee[]
}

export type ListPackagesProductsData = {
    type: ActionType.ListPackages,
    packageProducts: PackageProduct[]
}

export type SetCourseProductName = {
    type:ActionType.SetCourseProductName,
    name:string
}

export type GetCourseProductName = {
    type:ActionType.GetCourseProductName,
    name:string
}

export type SetCourseProductIntensity={
    type : ActionType.SetCourseProductIntensity ,
    id: number
}

export type SetCourseDivision={
    type : ActionType.SetCourseDivision ,
    id: number
}

export type GetAccommodationProduct ={
    type : ActionType.GetAccommodationProduct ,
    accommodation?: AccommodationProduct
}

export type  GetTransferProduct={
    type : ActionType.GetTransferProduct ,
    transfer: TransfersProduct 
}

export type GetAddonProduct ={
    type : ActionType.GetAddonProduct ,
    addon: AddOnsProduct 
}

export type GetFeeProduct = {
    type: ActionType.GetFeeProduct,
    fee?: Fee
}

export type GetCancellationFeeProduct = {
    type: ActionType.GetCancellationFeeProduct,
    cancellationFee?: CancellationFee
}

export type CancelShowDeleteCancellationFeeAction = {
    type: ActionType.CancelShowDeleteCancellationFeeAction
}

export type UpdateDraftCancellationFeeProduct = {
    type: ActionType.UpdateDraftCancellationFeeProduct,
    draftProduct?: CancellationFee
}

export type LoadDraftCancellationFeeProduct = {
    type: ActionType.LoadDraftCancellationFeeProduct,
    draftProduct?: CancellationFee
}

export type GetPackageProduct = {
    type: ActionType.GetPackageProduct,
    packageProduct: PackageProduct
}

export type CancelShowDeleteCourseAction = {
    type: ActionType.CancelShowDeleteCourseAction
}

export type CancelShowDeleteAccommodationAction = {
    type: ActionType.CancelShowDeleteAccommodationAction
}

export type formErrors = {
    type: ActionType.SetFormErrors,
    formErrors: FormError[]
}


export type UpdateDraftAccommodationProduct = {
    type: ActionType.UpdateDraftAccommodationProduct,
    draftProduct: AccommodationProduct,
}

export type LoadDraftAccommodationProduct = {
    type: ActionType.LoadDraftAccommodationProduct,
    draftProduct: AccommodationProduct
}

export type CancelShowDeleteFeeAction = {
    type: ActionType.CancelShowDeleteFeeAction
}
export type UpdateDraftFeeProduct = {
    type: ActionType.UpdateDraftFeeProduct,
    draftProduct: Fee,
}

export type LoadDraftFeeProduct = {
    type: ActionType.LoadDraftFeeProduct,
    draftProduct: Fee
}

export type CancelShowDeleteAddOnAction = {
    type: ActionType.CancelShowDeleteAddOnAction
}
export type UpdateDraftAddOnProduct = {
    type: ActionType.UpdateDraftAddOnProduct,
    draftProduct: AddOnsProduct,
}

export type LoadDraftAddOnProduct = {
    type: ActionType.LoadDraftAddOnProduct,
    draftProduct: AddOnsProduct
}

export type UpdateDraftTransferProduct = {
    type: ActionType.UpdateDraftTransferProduct,
    draftProduct: TransfersProduct
}
    
export type LoadDraftTransferProduct = {
    type: ActionType.LoadDraftTransferProduct,
    draftProduct: TransfersProduct
}

export type CancelShowDeleteTransferAction = {
    type: ActionType.CancelShowDeleteTransferAction
}

export type CancelShowDeletePackageAction = {
    type: ActionType.CancelShowDeletePackageAction
}

export type UpdateDraftPackageProduct = {
    type: ActionType.UpdateDraftPackageProduct,
    draftProduct: PackageProduct
}

export type LoadDraftPackageProduct = {
    type: ActionType.LoadDraftPackageProduct,
    draftProduct: PackageProduct
}

export type Action = 
    PageLoadedEvent 
    | ChangeSearchTerm 
    | ChangeSelectedProductType 
    | FilterData 
    | ListAccommodationProductsData 
    | ListCourseProductsData 
    | ListTransfersProductsData 
    | ListAddOnsProductsData 
    | ListFeesProductsData
    | ListCancellationFeesProductsData
    | ListPackagesProductsData
    | GetCourseProductData 
    | GetPackageProduct
    | ListFeesProductsData
    | SetCourseProductIntensity
    | SetCourseProductName 
    | SetCourseDivision
    | GetCourseProductName 
    | GetAccommodationProduct 
    | GetTransferProduct 
    | GetAddonProduct
    | GetFeeProduct
    | CancelShowDeleteCourseAction
    | CancelShowDeleteAccommodationAction
    | formErrors
    | UpdateDraftAccommodationProduct
    | LoadDraftAccommodationProduct
    | CancelShowDeleteAddOnAction
    | UpdateDraftAddOnProduct
    | LoadDraftAddOnProduct
    | CancelShowDeleteFeeAction
    | GetCancellationFeeProduct
    | CancelShowDeleteCancellationFeeAction
    | UpdateDraftCancellationFeeProduct
    | LoadDraftCancellationFeeProduct
    | UpdateDraftFeeProduct
    | LoadDraftFeeProduct
    | UpdateDraftTransferProduct
    | LoadDraftTransferProduct
    | CancelShowDeleteTransferAction
    | CancelShowDeletePackageAction
    | UpdateDraftPackageProduct
    | LoadDraftPackageProduct;